import { useEffect, useRef, useState } from 'react';
import { CSSTransition } from 'react-transition-group';

import { Field, Text } from '@sitecore-jss/sitecore-jss-nextjs';

import { Button } from 'src/components/basicContent/_Button/Button';

import ChevronRightIconSvg from 'public/icons/ChevronRight.svg';

import styles from './_MenuHeading.module.css';

type MenuHeadingProps = {
	menuTitle: Field<string>;
	selectedMenuItemTitle?: Field<string>;
	showSubMenu?: boolean;
	setSelectedMenuItemTitle?: (value: Field<string>) => void;
	clearMenuSelection: (value: boolean) => void;
};

export default function MenuHeading(props: MenuHeadingProps): JSX.Element {
	const [showMenuBreadcrumb, setShowMenuBreadcrumb] = useState(false);
	const transitionDuration = 200;

	const textRef = useRef<HTMLSpanElement>(null);
	useEffect(() => {
		if (props.selectedMenuItemTitle && props.selectedMenuItemTitle?.value?.trim() !== '') {
			setShowMenuBreadcrumb(true);
		}
	}, [props.selectedMenuItemTitle]);

	return (
		<div className={`${styles.heading} pad-x`}>
			<Button
				title={props.menuTitle?.value}
				type="button"
				className={`buttonReset ${styles.button} ${showMenuBreadcrumb ? styles.active : ''}`}
				onClick={() => {
					setShowMenuBreadcrumb(false);
					props.setSelectedMenuItemTitle?.({ value: '' });
					props.clearMenuSelection(false);
				}}
			>
				<Text field={props.menuTitle} />
				{showMenuBreadcrumb ? <ChevronRightIconSvg className={styles.chevron} /> : <></>}
			</Button>

			{props.showSubMenu && (
				<CSSTransition nodeRef={textRef} in={showMenuBreadcrumb} timeout={transitionDuration} classNames={{ ...styles }}>
					<span ref={textRef} className={styles.text}>
						<Text field={props.selectedMenuItemTitle} />
					</span>
				</CSSTransition>
			)}
		</div>
	);
}
